/*
 * Copyright (c) 2020, Neustar, Inc.
 * UNPUBLISHED PROPRIETARY SOURCE CODE
 *
 */

import { call, put } from "redux-saga/effects";
import _ from "lodash";
import axios from "../common/axios";
import actions from "../actionTypes";
import urls from "./URLS";
import localConfig from "../common/localConfig";
import getCookie from "../common/helpers/getCookie";
import { clearCookies } from "../common/helpers/getCookie";

export default function* sendRequest(action) {
  let absUrl;
  if (action.payload.mockApi) {
    absUrl = `${localConfig.contextPath}/${action.payload.endpoint}`;
  } else {
    absUrl = `${urls[action.payload.app]}/${action.payload.endpoint}`;
  }
  let key = (action.payload.keyPrefix) ?
              `endpoints.${action.payload.app}.${action.payload.endpoint}.${action.payload.keyPrefix}.${action.method}` :
              `endpoints.${action.payload.app}.${action.payload.endpoint}.${action.method}`;
  let ajaxConfig = {
    method: action.method.toUpperCase(),
    headers: {
      "Content-Type": "application/json",
    },

    url: absUrl,
  };
  if (action.payload.appendToEndpoint) {
    ajaxConfig.url += action.payload.appendToEndpoint;
  }
  if (action.payload.params) {
    ajaxConfig.params = action.payload.params;
  }
  if (action.payload.data) {
    ajaxConfig.data = action.payload.data;
  }
  if (action.payload.headers) {
    ajaxConfig.headers = action.payload.headers;
  }
  let isFetchingKey = `${key}.isFetching`;
  let responseKey = `${key}.response`;
  if (action.payload.keySuffix) {
    isFetchingKey = `${isFetchingKey}.${action.payload.keySuffix}`;
    responseKey = `${responseKey}.${action.payload.keySuffix}`;
  }
  yield put({
    type: actions.SET_IN_REDUX,
    payload: {
      path: isFetchingKey.split("."),
      data: true,
    },
  });
  try {
    let response = yield call(axios, ajaxConfig);
    //response.data['id'] = new Date().getTime();
    // This is needed in the case that a user has multiple tabs open and
    // logs out of one of the tab. Then the other tabs should also require
    // authentication again.
    if (
      response.status === 401 ||
      (response.status === 403 && response.data.message === "Forbidden")
    ) {
      yield put({
        type: actions.SET_IN_REDUX,
        payload: {
          path: "endpoints.hasError".split("."),
          data: {
            show: true,
            type: "unauthorized",
            message: null,
          },
        },
      });
    }
    if (_.isArray(response.data) && action.payload.keySuffix) {
      _.forEach(response.data, (v) => {
        v.keySuffix = action.payload.keySuffix;
      });
    }
    if (_.isArray(response.data) && action.payload.attachToResponse) {
      _.forEach(response.data, (v) => {
        v.requestInfo = action.payload.attachToResponse;
      });
    }
    if (_.isObject(response.data) && action.payload.keySuffix) {
      response.data.keySuffix = action.payload.keySuffix;
    }
    if (_.isObject(response.data) && action.payload.attachToResponse) {
      response.data.requestInfo = action.payload.attachToResponse;
    }
    //This is needed to redirect reponse to new tab, where user can access zendesk help resources
    //Mainly added for Zendesk help integration in P1
    if (_.isString(response.data) && _.isString(action.payload.responseRedirect)) {
      if (_.isEqual(action.payload.responseRedirect, 'zendesk') && response.status === 200) {
        window.open(response.data, '_blank', 'noopener,noreferrer');
      }

    }
    yield put({
      type: actions.SET_IN_REDUX,
      payload: {
        path: responseKey.split("."),
        data: response.data,
      },
    });
    if (action.payload.subsequentAction) {
      yield put(action.payload.subsequentAction);
    }
  } catch (e) {
    console.log(`error in sendRequest`);
    console.log("action");
    console.log(action);
    console.log("e.name: ");
    console.log(e.name);
    console.log("e.message: ");
    console.log(e.message);
    if(e.response) { // Handling 504 response status
      console.log(e.response);
      console.log(e.response.status);
      console.log(e.response.data);
      let type = "";
      if (
        !action.payload.endpoint.includes("reach") &&
        !action.payload.endpoint.includes("isegs")
      ) {
        if (
          e.message.includes("401") ||
          e.message.includes("403") ||
          _.get(getCookie("sessionAttributes"), "userId") === 0
        ) {
          // Handle un authorized error. may be logout the user or something..
          // type = 'unAuthorized'
          window.location = `${
            window.location.origin
          }/manage/#/saml/sso/logout?email=${""}`;
          window.localStorage.clear();
        } else if (
          e.message.includes("404") ||
          e.message.includes("503") ||
          e.message.includes("500") || 
          e.message.includes("504")
        ) {
          type = "notFound";
        } else {
          yield put({
            type: actions.SET_IN_REDUX,
            payload: {
              path: "endpoints.hasError".split("."),
              data: {
                show: true,
                type,
                message: e.response.data.message || null,
              },
            },
          });
        }
      }
    }

    // if (e.message.includes("403") || e.message.includes("401") || e.message.includes("")) {
    //   console.error("403");
    //   //window.location = `${localConfig.contextPath}/`;
    //   window.location = '/';
    // }
    console.error("e: ");
    console.error(e);
    //yield* handleError({id: action.payload.url, title: action.payload.url, error});
  } finally {
    yield put({
      type: actions.SET_IN_REDUX,
      payload: {
        path: isFetchingKey.split("."),
        data: false,
      },
    });
  }
}
